export const calcWindowHeight = () =>{
    let windowHeight = window.innerHeight;
    //グローバルフッターナビの高さを取得
    const gfNav = document.getElementById('gf_nav');
    const gfNavHeight = gfNav.clientHeight;
    //グローバルヘッダーナビの高さを取得
    const ghNav = document.getElementById('gh_nav');
    const ghNavHeight = ghNav.clientHeight;
    //H1ヘッダーの高さを取得
    // const h1Header = document.getElementById('header-h1');
    // const h1HeaderHeight = h1Header.clientHeight;
    //windowHeight -= (gfNavHeight + ghNavHeight + h1HeaderHeight);
    windowHeight -= (gfNavHeight + ghNavHeight);
    return windowHeight;

}

export const adjustImageSizes = (CR) => {
  if(CR==null){ return false; }
  const carouselItems = document.querySelectorAll('#top-carousel .carousel-item');
  let windowHeight = calcWindowHeight();
  CR.style.height = windowHeight + 'px';
  CR.style.minHeight = windowHeight + 'px';
  document.getElementById(`wrapper-carousel`).style.height = windowHeight + 'px';
  carouselItems.forEach((v) => {
    const dataCarousel = v.getAttribute('data-carousel');

    v.style.overflow = 'hidden';
    v.style.height = windowHeight + 'px';
    v.style.position = 'absolute';
    v.style.top = '0';
    v.style.left = '0';
    v.style.right = '0';
    v.style.bottom = '0';
    const img = v.querySelector('.carousel-image');
    img.style.position = 'absolute';
    img.style.top = '50%';
    img.style.left = '50%';
    img.style.width = '100%';
    img.style.height = windowHeight + 'px';
    img.style.objectFit = 'cover';
    img.style.transform = 'translate(-50%, -50%)';
    // if(dataCarousel==='7'){
    //   console.log('dataCarousel 7');
    //   img.style.transform = 'translate(-50%, -50%) scale(1.5)';
    //   //img.style.animation = 'zoomOut 11s ease-out forwards'; /* アニメーションを適用 */
    // }else{
    // }


    if (img.height < windowHeight) {
      img.style.height = windowHeight + 'px';
      img.style.width = 'auto';
    }
  });
};
// 流れ星を表示する関数
function displayShootingStars(carouselItem) {
  console.log('displayShootingStars');

  const numberOfStars = 3; // 表示する流れ星の数
  const stars = [];

  for (let i = 0; i < numberOfStars; i++) {
    let shootingStar = document.createElement('span');
    shootingStar.classList.add('shooting-star');

    // ランダムな位置を設定 (横方向、縦方向の初期位置)
    const randomTop = Math.floor(Math.random() * 100) - 50; // -50pxから50pxまで
    const randomLeft = Math.floor(Math.random() * window.innerWidth); // 画面全体の横方向からランダム

    //const randomLeft = Math.floor(Math.random() * 100); // -50pxから50pxまで

    shootingStar.style.top = `${randomTop}px`;
    shootingStar.style.left = `${randomLeft}px`;

    carouselItem.appendChild(shootingStar);
    stars.push(shootingStar);
  }

  stars.forEach(star => {
    // ランダムなタイミングでアニメーションを開始
    const randomDelay = Math.random() * 6 + 3; // 1から10秒の間でランダムな遅延
    star.style.animationDelay = `${randomDelay}s`;
    star.classList.add('active-shooting-star');
  });

  const numberOfTwinkles = 15; // 表示するｷﾗｷﾗ星の数
  for (let i = 0; i < numberOfTwinkles; i++) {
    let twinkle = document.createElement('span');
    twinkle.classList.add('twinkling-star');
    // ランダムな位置を設定 (横方向、縦方向の初期位置)
    const randomTop = Math.floor(Math.random() * window.innerHeight)-(window.innerHeight/3*2); // 画面全体の縦方向上部2/3からランダム
    const randomLeft = Math.floor(Math.random() * window.innerWidth); // 画面全体の横方向からランダム
    const randomSize = (Math.random() * 2 + 1).toFixed(2);
    //const randomLeft = Math.floor(Math.random() * 100); // -50pxから50pxまで
    twinkle.style.top = `${randomTop}px`;
    twinkle.style.left = `${randomLeft}px`;
    twinkle.style.width = `${randomSize}px`;
    twinkle.style.height = `${randomSize}px`;
    carouselItem.appendChild(twinkle);
  }
}
// 流れ星を非表示にする関数
function removeShootingStar() {
  const shootingStar = document.querySelector('.shooting-star');
  if (shootingStar) {
    shootingStar.style.display = 'none'; // 流れ星を非表示にする
    shootingStar.classList.remove('active-shooting-star'); // アニメーションクラスを削除
  }
  const twinklingStars = document.querySelectorAll('.twinkling-star');
  // すべてのｷﾗｷﾗ星を削除
  twinklingStars.forEach(star => {
    star.remove();
  });

}

export const topCarousel = () => {

  return new Promise((resolve, reject) => {
    const CR = document.getElementById('top-carousel');
    if (CR === null) {
      resolve('Carousel element not found');
      return false;
    }
    console.log('top carousel');
    try {
      window.onload= () =>{
        adjustImageSizes(CR);

        let currentIndex = 0;
        const carouselItems = document.querySelectorAll('#top-carousel .carousel-item');

        const handleShootingStars = (nextItem) => {
          const dataCarousel = nextItem.getAttribute('data-carousel');
          if (dataCarousel === '3') {
            displayShootingStars(nextItem);
          } else {
            setTimeout(() => {
              removeShootingStar();
            }, 3000);
          }
        };

        /**---------------------------------------------
         * 指定したクラスを追加してアニメーションを実行する
        **-----------------------------------------------*/
        const handleImageAnimation = (nextItem) => {
          const dataCarousel = nextItem.getAttribute('data-carousel');
          if (dataCarousel === '7') {
            nextItem.querySelector(`.carousel-image`).classList.add('carousel-image-animation');
          } else {
            setTimeout(() => {
              const carouselImage = document.querySelector(`[data-carousel="7"] .carousel-image`);
              if (carouselImage.classList.contains('carousel-image-animation')) {
                carouselImage.classList.remove('carousel-image-animation');
              }
            }, 3000);
          }
        };

        const showNextImage = () => {
          const activeItem = carouselItems[currentIndex];
          const textElement = activeItem.querySelector('.carousel-title');

          /**---------------------------------------------
           * 0.5秒後にactiveクラスを削除する
          **-----------------------------------------------*/
          setTimeout(() => {
            activeItem.classList.remove('active');
          }, 500);

          /**---------------------------------------------
           * 3秒後にanimate-textクラスを削除する
          **-----------------------------------------------*/
          if (textElement) {
            setTimeout(() => {
              textElement.classList.remove('animate-text');
            }, 3000);
          }

          currentIndex = (currentIndex + 1) % carouselItems.length;
          const nextItem = carouselItems[currentIndex];
          nextItem.classList.add('active');

          const nextTextElement = nextItem.querySelector('.carousel-title');
          if (nextTextElement) {
            setTimeout(() => {
              nextTextElement.classList.add('animate-text');
            }, 100);
          }


          handleShootingStars(nextItem);
          handleImageAnimation(nextItem);
        };

        carouselItems[currentIndex].classList.add('active');
        const firstTextElement = carouselItems[currentIndex].querySelector('.carousel-title');
        if (firstTextElement) {
          firstTextElement.classList.add('animate-text');
        }

        setInterval(showNextImage, 10000);
        resolve('Carousel initialized successfully');
      };
    } catch (error) {
      reject(error);
    }
  });
};

export const announceCarousel = () => {
  const carousel = document.querySelector('.announce_carousel');
  const items = document.querySelectorAll('.announce_carousel-item');
  const dotsContainer = document.querySelector('.announce_carousel-dots');
  if(carousel==null||items==null||dotsContainer==null){ return false; }

  let currentIndex = 0;
  let itemWidth = items[0].getBoundingClientRect().width;
  let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0;
  let animationID, autoSlideIntervalID;

  const createDots = () => {
    items.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.classList.add('dot');
      if (index === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        moveToSlide(index);
        resetAutoSlide();
      });
      dotsContainer.appendChild(dot);
    });
  };

  const setSliderPosition = () => {
    carousel.style.transform = `translateX(${currentTranslate}px)`;
  };

  const moveToSlide = (index) => {
    currentIndex = index;
    currentTranslate = -(currentIndex * itemWidth);
    setSliderPosition();
    setActiveDot();
  };

  const setActiveDot = () => {
    const dots = document.querySelectorAll('.dot');
    dots.forEach(dot => dot.classList.remove('active'));
    dots[currentIndex].classList.add('active');
  };

  const resetAutoSlide = () => {
    clearInterval(autoSlideIntervalID);
    autoSlideIntervalID = setInterval(() => {
      moveToSlide((currentIndex + 1) % items.length);
    }, 5000);
  };

  const startDragging = (pos) => {
    isDragging = true;
    startPos = pos;
    currentTranslate = prevTranslate;
    cancelAnimationFrame(animationID);
  };

  const duringDragging = (pos) => {
    if (isDragging) {
      const currentPosition = pos;
      const moveX = currentPosition - startPos;
      currentTranslate = prevTranslate + moveX;
      requestAnimationFrame(setSliderPosition);
    }
  };

  const endDragging = () => {
    isDragging = false;
    const movedBy = currentTranslate - prevTranslate;
    if (movedBy < -50) { // 左スワイプ（次のスライドへ）
      if (currentIndex < items.length - 1) currentIndex += 1;
    } else if (movedBy > 50) { // 右スワイプ（前のスライドへ）
      if (currentIndex > 0) currentIndex -= 1;
    }
    moveToSlide(currentIndex);
    prevTranslate = currentTranslate;
    resetAutoSlide();
  };

  carousel.addEventListener('mousedown', (e) => {
    e.preventDefault();
    startDragging(e.pageX);
  });

  carousel.addEventListener('mousemove', (e) => {
    duringDragging(e.pageX);
  });

  carousel.addEventListener('mouseup', endDragging);
  carousel.addEventListener('mouseleave', endDragging);

  carousel.addEventListener('touchstart', (e) => {
    const touch = e.touches[0];
    startDragging(touch.pageX);
  });

  carousel.addEventListener('touchmove', (e) => {
    const touch = e.touches[0];
    duringDragging(touch.pageX);
  });

  carousel.addEventListener('touchend', endDragging);
  carousel.addEventListener('touchcancel', endDragging);

  window.addEventListener('resize', () => {
    itemWidth = items[0].getBoundingClientRect().width;
    moveToSlide(currentIndex);
  });

  createDots();
  resetAutoSlide();
};